/**
 * Cadastro das permissoes da plataforma.
 *
 * Uma permissao e o par (ferramenta, acao). A tela nao cria nem apaga nenhuma
 * das duas -- quem faz isso e a aplicacao que expoe o endpoint. O que se faz
 * aqui e dar nome, descricao, tipo e codigo, que e o que permite conceder com
 * consciencia do que se esta concedendo, e o que permite o codigo perguntar
 * "esta pessoa pode ver esta tela?".
 */
export const nav = {
    section: 'Resources',
    title: 'Permissions',
    icon: 'key',
    route: '/permissoes',
    accordion: false,
    permissao: 'accounts.permissoes:ver',
};

export default [
    {
        path: '/permissoes',
        name: '/permissoes',
        component: () => import('./pages/PermissoesListPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.permissoes:ver' },
    },
];
